import { render } from "./SystemTemplate.vue?vue&type=template&id=ab9da95c"
import script from "./SystemTemplate.vue?vue&type=script&lang=js"
export * from "./SystemTemplate.vue?vue&type=script&lang=js"

import "./SystemTemplate.vue?vue&type=style&index=0&id=ab9da95c&lang=scss"

import exportComponent from "/var/www/documentation.probabilityworks.cloud/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__